import { motion } from "framer-motion";

import Block3Columns from "../../components/Block3Columns";
import ImageContainer from "../../components/ImageContainer";
import Block2ColumnsText from "../../components/Block2ColumnsText";
import MasonryGallery from "../../components/MasonryGallery";
import DataFetcherTemplateHome2 from "../../hooks/DataFetcherTemplate2";
import { FileText, Download } from "lucide-react";

const url =
  "https://be-portales.utpl.edu.ec/jsonapi/node/template_home/e25b36b3-54eb-4165-8c69-d045b20bba28" +
  "?include=" +
  "field_imagen_portada.field_media_image," +
  "field_imagen1.field_media_image," +
  "field_imagen2.field_media_image," +

  // 🔥 DOCUMENTOS
  "field_documento_1.field_media_document," +
  "field_documento_2.field_media_document" +

  "&fields[node--template_home]=" +
  "title," +
  "field_documento_1," +
  "field_documento_2," +
  "field_imagen_portada," +
  "field_texto_portada,"+
    "field_bloque1,field_bloque2";

function PresencialHorarios() {
  const DataDisplay = ({ data }) => (
    <div>
         <div className="margin pt-10 text-center"
        dangerouslySetInnerHTML={{
          __html: data.texto_portada,
        }}
      />

<div className="max-w-6xl mx-auto py-10">
  <div className="grid gap-4 md:grid-cols-2">
    
    {data.documento1 && (
      <a
        href={data.documento1}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center justify-between rounded-2xl border border-gray-200 bg-white p-5 shadow-sm transition-all duration-300 hover:border-blue-500 hover:shadow-lg"
      >
        <div className="flex items-center gap-4">
          <div className="rounded-xl bg-blue-100 p-3 text-blue-600">
            <FileText size={28} />
          </div>

          <div>
            <p className="text-lg font-semibold text-gray-800">
             Términos y condiciones para menores de edad
            </p>

            <p className="text-sm text-gray-500">
              Descargar archivo PDF
            </p>
          </div>
        </div>

        <Download
          size={22}
          className="text-gray-400 transition group-hover:text-blue-600"
        />
      </a>
    )}

    {data.documento2 && (
      <a
        href={data.documento2}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center justify-between rounded-2xl border border-gray-200 bg-white p-5 shadow-sm transition-all duration-300 hover:border-blue-500 hover:shadow-lg"
      >
        <div className="flex items-center gap-4">
          <div className="rounded-xl bg-green-100 p-3 text-green-600">
            <FileText size={28} />
          </div>

          <div>
            <p className="text-lg font-semibold text-gray-800">
          Términos y condiciones para mayores de edad
            </p>

            <p className="text-sm text-gray-500">
              Descargar archivo PDF
            </p>
          </div>
        </div>

        <Download
          size={22}
          className="text-gray-400 transition group-hover:text-green-600"
        />
      </a>
    )}

  </div>
</div>

      <div className="pt-10 margin"
        dangerouslySetInnerHTML={{
          __html: data.bloque2,
        }}
      />

 
    </div>
  );


  return (
    <DataFetcherTemplateHome2 url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome2>
  );
}

export default PresencialHorarios;
